import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Button,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import useAddGradeHook from "../hooks/AdditionalGradeHook";
import { useTheme } from "@mui/material/styles";
import SchoolNotificationButton from "../../../CcpConstants/SchoolNotificationButton";
import GetCoordIds from "../../../CcpConstants/GetCoordIds";

const AdditionalGradeReport = ({ schoolId, linkColor }) => {
  const { data, loading } = useAddGradeHook(schoolId);
  const report_1_name = data.length > 0 ? data[0].report_1_name : "";
  const report_1_link = data.length > 0 ? data[0].report_1_link : "";
  const report_2_name = data.length > 0 ? data[0].report_2_name : "";
  const report_2_link = data.length > 0 ? data[0].report_2_link : "";
  const {
    pathwayEmail,
    opEmail,
    loading: emailsLoading,
    error: emailsError,
  } = GetCoordIds(schoolId);
  const theme = useTheme();

  useEffect(() => {
    console.log("schoolId:", schoolId); // Log the schoolId
    console.log("pathwayEmail:", pathwayEmail); // Log pathwayEmail
    console.log("opEmail:", opEmail); // Log opEmail
    console.log("emailsLoading:", emailsLoading); // Log the loading state for emails
    if (emailsError) {
      console.error("Error fetching emails:", emailsError);
    }
    if (data && data.length > 0) {
      console.log("report_1_link", data[0].report_1_link);
    }
  }, [schoolId, pathwayEmail, opEmail, emailsLoading, emailsError, data]); // Add all dependencies

  if (loading || emailsLoading) {
    // Include emailsLoading in the conditional rendering check
    return <div>Loading...</div>;
  }

  if (emailsError) {
    return <div>Error: {emailsError.message}</div>; // Display error message if there's an issue fetching emails.
  }

  // Use report_1_name as title, fallback to "Grade Change Report" if not set
  const cardTitle = report_1_name || "Grade Change Report";
  const subject = cardTitle;

  return (
    <Card>
      <CardHeader
        title={cardTitle}
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {report_1_link && (
          <Box
            sx={{
              display: "flex",
              gap: 2,
              alignItems: "center",
              marginBottom: 2,
            }}
          >
            <Button
              variant="contained"
              component="a"
              href={report_1_link}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                backgroundColor: "#AC1A2F",
                color: "white",
                "&:hover": {
                  backgroundColor: "#8B0000",
                },
              }}
            >
              View Report
            </Button>
            <SchoolNotificationButton
              subject={subject}
              schoolId={schoolId}
              pathwayEmail={pathwayEmail}
              opEmail={opEmail}
            />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default AdditionalGradeReport;
